export default __webpack_public_path__ + "7c4e89c6833ba61a51bdb65b03474f22.png";